import { fetchIStatus } from '@/shared/fetchIStatus';
import { IPet } from '@/shared/interfaces';

export const editPet = async (petData: IPet) => {
    return await fetchIStatus<string, IPet>('/api/pets', 'PUT', petData);
};
